import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '配信期間',

  // 選択サービス名
  serviceName: null,

  // model
  deliveryTypeModel: []
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {deliveryTypeParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceDeliveryType'],
        ['v1ServiceDeliveryTypeListGet'],
        [deliveryTypeParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceName', res[0].data.serviceName)
            commit('setDeliveryTypeModel', res[0].data.serviceDeliveryTypes)
            console.log('deliveryTypeModel', state.deliveryTypeModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
  // service name
  setServiceName (state, str) {
    state.serviceName = str
  },
  // model
  setDeliveryTypeModel (state, data) {
    Vue.set(state, 'deliveryTypeModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
